import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Table } from '@sar/component'
import { UploadImage, UploadFile } from 'components'

import { Spin } from 'antd'
import { ProForm } from '@ant-design/pro-components'

const getData = (data, type) => (
  data
    .filter(e => e.type == type)
    .map(e => ({ url: e.url, filename: e.fileName }))
)

export default function ({ store, params, navigator }) {
  const fileType = React.useMemo(() => {
    return store.config.getConstantPairs('FileType')
  }, [])

  const res = useRequest<any, any>(async () => {
    const result = await store.externals.api.get(`/design/${params.id}`)

    return Object.assign(result, {
      formData: {
          order: getData(result.fileManageList, fileType.blueprint)
        , log: getData(result.fileManageList, fileType.chatRecords)
        , sign: getData(result.fileManageList, fileType.autograph)
        , blueprint: getData(result.fileManageList, fileType.measurement)
      }
    })
  }, {
    manual: true
  })

  const handleSave = useRequest(async (data, type) => {
    return store.externals.api.put(`/design/upload/${params.id}?type=${type}`, data.map(elm => {
      return {
        url: elm.url,
        fileName: elm.filename,
      }
    }))
  }, {
    manual: true,
  })

  return <div className='p-4 m-4 bg-white'>
    <Spin spinning={res.loading} tip='加载中...'>
      <table className='w-full border-collapse border border-slate-300 mb-2'>
        <tbody>
          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>客户姓名</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerName}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>电话</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerPhone}</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>设计师</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.designerName}</td>
            <td className='border border-slate-300 text-right p-3 w-1/4 bg-gray-100'>来源</td>
            <td className='border border-slate-300 text-left p-3 w-1/4'>{res.data?.customerSource}</td>
          </tr>
        </tbody>
      </table>
    </Spin>

    <ProForm
      rowProps={{ gutter: 24 }}
      layout='vertical'
      onFinish={() => navigator.back()}
      request={() => res.runAsync().then(R.prop('formData'))}
      readonly={!store.identity.hasPermission('/design/list:upload')}
      submitter={!store.identity.hasPermission('/design/list:upload') ? false : {
        searchConfig: {
          submitText: '确定',
        },
        resetButtonProps: {
          style: {
            display: 'none',
          },
        },
      }}
    >
      <UploadImage
        max={10000}
        name='order'
        label='上传确认下单图纸'
        help='建议尺寸800*800px'
        onSave={e => handleSave.runAsync(e, fileType.blueprint)}
        readonly={!store.identity.hasPermission('/design/list:upload')}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />

      <UploadImage
        max={10000}
        name='blueprint'
        label='上传现场量尺照片'
        help='建议尺寸800*800px'
        onSave={e => handleSave.runAsync(e, fileType.measurement)}
        readonly={!store.identity.hasPermission('/design/list:upload')}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />

      <UploadFile
        max={10}
        name='log'
        label='上传聊天记录及电话录音'
        onSave={e => handleSave.runAsync(e, fileType.chatRecords)}
        readonly={!store.identity.hasPermission('/design/list:upload')}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />

      <UploadImage
        max={10000}
        name='sign'
        label='上传客户签字图纸照片'
        help='建议尺寸800*800px'
        onSave={e => handleSave.runAsync(e, fileType.autograph)}
        readonly={!store.identity.hasPermission('/design/list:upload')}
        fieldProps={{ upload: file => store.oss.client.multipartUpload(`${store.externals.nonce()}.${file.name.split('.').pop()}`, file).then(res => `//${store.oss.endpoint}/${res.name}`) }}
      />
    </ProForm>
  </div>
}
